import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { locale } from "../../utils/LocaleManager";
import { useContentStore } from "../../stores/contentStore";
import { TagTypeEnum } from "../../enums/TagTypeEnum";

const TableMenu = (props: any) => {
  const setIsShowDeleteTagDialog = useContentStore(
    (state: any) => state.setIsShowDeleteTagDialog,
  );

  return (
    <>
      <Menu
        anchorEl={props?.anchorEl}
        open={props?.open}
        onClose={() => {
          props?.setSelectedRow(null);
          props?.setOpen(false);
        }}
        anchorReference={props?.contextMenu ? "anchorPosition" : "anchorEl"}
        anchorPosition={
          props?.contextMenu !== null
            ? {
                top: props?.contextMenu.mouseY,
                left: props?.contextMenu.mouseX,
              }
            : undefined
        }
      >
        <MenuItem
          key={"play"}
          onClick={() => {
            props?.setOpen(false);
            props.onMarkDeletion();
            setIsShowDeleteTagDialog(true);
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {props?.selectedRow?.type === TagTypeEnum.transcript
              ? locale.deleteTranscript
              : locale.deleteTag}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default TableMenu;
